import { service } from '@ember/service'
import Controller from '@ember/controller'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'

export default class FinishController extends Controller {
  @service subscriptionType!: SubscriptionTypeService

  /**
   * From the context of only Reading or Maths rollovers, and ignoring impacts that a Reading/Maths rollover will have
   * on the Writing management features, we can still use the term "opposite" here.
   *
   * When we support Writing rollovers, we'll want to change this terminology to _other_ subscription types (plural)
   */
  get oppositeSubscriptionType(): SubscriptionType.Reading | SubscriptionType.Maths {
    switch (this.subscriptionType.current) {
      case SubscriptionType.Reading:
        return SubscriptionType.Maths
      case SubscriptionType.Maths:
        return SubscriptionType.Reading
      default:
        return SubscriptionType.Reading
    }
  }
}
